<template>
  <button
    class="z-[5999] flex h-12 w-12 items-center justify-center rounded-full bg-point-color p-2"
    @click="scrollToTop"
  >
    <FontAwesomeIcon
      icon="chevron-up"
      class="text-primary"
      size="lg"
    />
  </button>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const scrollToTop = () => {
  if (process.client) {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
</script>

<style scoped lang="scss">

</style>